import { combineEpics } from "redux-observable";
import { provideGAREpics } from "./GarEpic.js";
import { garLogPerformanceEpics } from "../actions/GarLogPerformanceEpics.js";
import history from "@ane/core/lib/CreateHistory";
const garModuleEpic = combineEpics(provideGAREpics(history), garLogPerformanceEpics);
export {
  garModuleEpic as default,
  garModuleEpic
};
//# sourceMappingURL=epics.js.map
